import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';
import CellRendererVerified from "../../views/components/ag-grid/cell-renderer/CellRendererVerified";

export default [
  {
    headerName: 'SubmissionCode',
    field: 'GeneratedServiceCode',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'DateOfSubmission',
    field: 'DateOfSubmission',
    filter: 'agDateColumnFilter',
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
    minWidth: 100,
  },
  {
    headerName: 'Status',
    field: 'SubmissionStatus',
    minWidth: 200,
  },
  {
    headerName: 'SubmitterName',
    field: 'SubmitterName',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredFirstName',
    field: 'InsuredFirstName',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredLastName',
    field: 'InsuredSurname',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredCompanyName',
    field: 'InsuredCompanyName',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredFiscalCode',
    field: 'InsuredFiscalCode',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'InsuredVATCode',
    field: 'InsuredVATCode',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'RemoteSignature',
    field: 'IsRemoteSignature',
    cellRenderer: "CellRendererVerified",
    minWidth: 200,
  },
  {
    headerName: 'SentToInsured',
    field: 'IsSentToInsured',
    cellRenderer: "CellRendererVerified",
    minWidth: 200,
  },
  {
    headerName: 'Referral',
    field: 'IsReferral',
    cellRenderer: "CellRendererVerified",
    minWidth: 200,
  },
  {
    headerName: 'Renewal',
    field: 'IsRenewal',
    cellRenderer: "CellRendererVerified",
    minWidth: 200,
  },
  {
    headerName: 'SubmissionNote',
    field: 'SubmitterNote',
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
];

